import React from "react";
import { Switch, Route } from "react-router-dom";

// import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import Reports from "./Reports/Reports";
import NotFound from "views/Welcome/NotFound";

const Illustrate = props => {
    return (
        <React.Fragment>
            {/* <ProtectedRoute> */}
            {/* Switch Routes below */}
            <Switch>
                <Route exact path="/illustrate/reports" component={Reports} />
                <Route component={NotFound} />
            </Switch>
            {/* </ProtectedRoute> */}
        </React.Fragment>
    );
};

export default Illustrate;
